/*
*
* File JS componente Block Scroll Carousel
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import galleryOverflow from 'components/gallery-overflow/gallery-overflow';

//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-scroll-carousel.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockScrollCarousel = () => {
    galleryOverflow();
}

export default blockScrollCarousel;

//--------------------------------------------------------------------//